import React, { useEffect, useState } from "react"; 
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./DeviceDetail.css";

const SOCKET_SERVER_URL_API = process.env.REACT_APP_SOCKET_SERVER_URL_API;

function DeviceDetail() {
    const navigate = useNavigate();
    const { deviceId } = useParams();
    const [deviceData, setDeviceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deviceList, setDeviceList] = useState([]);

    useEffect(() => {
        const fetchDevices = async () => {
            try {
                const response = await axios.get(`${SOCKET_SERVER_URL_API}/devices`);
                setDeviceList(response.data);
            } catch (error) {
                console.error("Error fetching device list:", error);
            }
        };

        fetchDevices();
    }, []);

    useEffect(() => {
        if (!deviceId) return;

        const fetchAverageData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${SOCKET_SERVER_URL_API}/bacteria-log/average/${deviceId}`);
                setDeviceData(response.data);
            } catch (error) {
                console.error("Error fetching average eLuxData:", error);
                setDeviceData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchAverageData();
    }, [deviceId]);

    const handleDeviceChange = (event) => {
        const selectedDevice = event.target.value;
        navigate(`/devices/${selectedDevice}`);
    };

    const progressPercentage =
        deviceData && deviceData.progress === "In Progress"
            ? deviceData.count === 0
                ? 0
                : Math.min(Math.round((deviceData.count / 72) * 100), 100)
            : null;

    return (
        <>
            <div className="device-dropdown">
                <label>Select Device:</label>
                <select value={deviceId || ""} onChange={handleDeviceChange}>
                    <option value="">-- Select a Device --</option>
                    {deviceList.map((device) => (
                        <option key={device} value={device}>
                            {device}
                        </option>
                    ))}
                </select>
            </div>

            <div className="device-detail-container">
                <div className="water-background">
                    <h2 className="title">Bacteria Detection</h2>
                    <h3 className="device-name">Device: {deviceId || "No Device Selected"}</h3>

                    {loading ? (
                        <p>Loading average eLux data...</p>
                    ) : deviceData ? (
                        <>
                            <div className="detection-box">
                                {deviceData.progress === "Complete" ? (
                                    <>
                                        <h1 className={deviceData.bacteriaResult === "Safe" ? "safe" : "high-risk"}>
                                            {deviceData.bacteriaResult === "Unknown" || deviceData.lowCount == null
                                                ? "Counting in progress"
                                                : deviceData.bacteriaResult}
                                        </h1>
                                        <p>Complete</p>
                                    </>
                                ) : deviceData.progress === "In Progress" ? (
                                    <div className="progress-ring">
                                        <div className="spinner"></div>
                                        <span className="progress-text">
                                            {progressPercentage !== null ? `${progressPercentage}% Complete` : "In Progress"}
                                        </span>
                                    </div>
                                ) : (
                                    <h1>{deviceData.progress}</h1>
                                )}
                            </div>

                            <div className="device-info">
                                <div className="detection-info">
                                    <div className="info-item">
                                    
                                    <p><strong>Instuctions:</strong> {(deviceData.eVoiceMessage)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="device-info">
                                <div className="detection-info">
                                    <div className="info-item">
                                        <span className="icon">📊</span>
                                        <p>Data Points Counted: {deviceData.count }</p>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">🧪</span>
                                        <p>Low Bacteria Count: {deviceData.lowCount != null ? deviceData.lowCount : "Counting in progress"}</p>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">⏱️</span>
                                        <p>Test Start Time: {new Date(deviceData.timestamp).toLocaleString()}</p>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">⏲️</span>
                                        <p>Test End Time: {new Date(deviceData.testEndTime).toLocaleString()}</p>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">🦠</span>
                                        <p>Average Bacterial Content: {3200 - deviceData.averageELux.toFixed(2)}</p>
                                    </div>
                                    <div className="info-item test-id">
                                        <span className="icon">🆔</span>
                                        <p>
                                            TestId: {" "}
                                            <span className="icon" title="TestId">
                                                {deviceData.testId}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">📅</span>
                                        <p>TestStatus: {deviceData.testStatus}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="reference-container">
                                <h3>Reference Standard for Bacterial Content</h3>
                                <div className="reference-labels">
                                    <span>&lt;1400 Clean</span>
                                    <span>1400 - 2200 Low Risk</span>
                                    <span>&gt;2600 High Risk</span>
                                </div>
                                <div className="reference-bar"></div>
                                <p className="reference-text">Reference standard: "Drinking Water Hygiene Standard"</p>
                            </div>
                        </>
                    ) : (
                        <p>No data available for this device.</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default DeviceDetail;
